<section class="content employees-detail-page">
  <div class="content-block employees-detail-page__content">
    <div class="block-header employees-detail-page__header">
      <app-breadcrumb [title]="'MENUITEMS.ORGANIZATION.TEXT' | translate"
                      [items]="breadcrumbItems"></app-breadcrumb>
    </div>

    <mat-card class="employees-detail-page__card"
              [class.employees-detail-page__card--loading]="isLoading">
      @if (isLoading) {
      <div class="employees-detail-page__loading">
        <app-loading-state [message]="'masterTable.loading' | translate" />
      </div>
      } @else {
      <div class="employees-detail-page__card-header">
        <div>
          <span class="employees-detail-page__eyebrow">{{ 'employeesCatalog.breadcrumb' | translate }}</span>
          <h3>{{ pageTitle }}</h3>
          <p>{{ 'employeesCatalog.detailDescription' | translate }}</p>
        </div>

        <div class="employees-detail-page__actions">
          @if (isViewMode && canEdit) {
          <button mat-stroked-button
                  class="btn-tone-primary"
                  type="button"
                  (click)="goToEdit()">
            <mat-icon>edit</mat-icon>
            {{ 'common.update' | translate }}
          </button>
          }

          @if (!isViewMode) {
          <button mat-flat-button
                  class="btn-tone-primary"
                  type="button"
                  [disabled]="isEmployeeSaveDisabled"
                  (click)="save()">
            <mat-icon>save</mat-icon>
            {{ isCreateMode ? ('employeesCatalog.actions.saveEmployee' | translate) : ('common.saveChanges' | translate) }}
          </button>
          }

          @if (canResetPassword) {
          <button mat-stroked-button
                  class="btn-tone-neutral"
                  type="button"
                  [disabled]="isLoading"
                  (click)="resetLinkedUserPassword()">
            <mat-icon>password</mat-icon>
            {{ 'employeesCatalog.resetPassword' | translate }}
          </button>
          }

          <button mat-stroked-button
                  class="btn-tone-neutral"
                  type="button"
                  (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            {{ 'common.back' | translate }}
          </button>
        </div>
      </div>

      <div class="employees-detail-page__body">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex"
                       class="employees-detail-page__tabs">
          <mat-tab [label]="'employeesCatalog.tabs.general' | translate">
            <div class="employees-detail-page__general-tab">
              <div class="employees-detail-page__general-layout">
                <div class="employees-detail-page__general-main">
                  <div class="employees-detail-page__section-card employees-detail-page__section-card--organization"
                       [class.employees-detail-page__section-card--complete]="isOrganizationComplete">
                    <div class="employees-detail-page__section-header employees-detail-page__section-header--step">
                      <div class="employees-detail-page__step-heading">
                        <span class="employees-detail-page__step-number">1</span>
                        <div>
                          <span class="employees-detail-page__step-eyebrow">{{ 'employeesCatalog.general.step' | translate:{ step: 1 } }}</span>
                          <h4>{{ 'employeesCatalog.general.sections.organization' | translate }}</h4>
                          <p>{{ 'employeesCatalog.general.descriptions.organization' | translate }}</p>
                        </div>
                      </div>
                      <span class="employees-detail-page__step-status"
                            [class.employees-detail-page__step-status--complete]="isOrganizationComplete">
                        <mat-icon>{{ isOrganizationComplete ? 'check_circle' : 'schedule' }}</mat-icon>
                        {{ (isOrganizationComplete ? 'employeesCatalog.general.stepComplete' : 'employeesCatalog.general.stepPending') | translate }}
                      </span>
                    </div>

                    <div class="employees-detail-page__form--organization">
                      @if (isViewMode) {
                      <mat-form-field subscriptSizing="dynamic" appearance="outline">
                        <mat-label>{{ 'employeesCatalog.fields.company' | translate }}</mat-label>
                        <input matInput
                               [value]="selectedCompanyName"
                               readonly>
                      </mat-form-field>
                      } @else {
                      <app-company-select [records]="companies" [value]="entityForm.companiesRecordId"
                                          [label]="'employeesCatalog.fields.company' | translate"
                                          [placeholder]="'employeesCatalog.fields.company' | translate"
                                          (valueChange)="entityForm.companiesRecordId = $event; onCompanyChange()" />
                      }

                      <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                      [class.employees-detail-page__org-unit-field--disabled]="!isViewMode && !canSelectOrgUnit">
                        <mat-label>{{ 'employeesCatalog.fields.orgUnit' | translate }}</mat-label>
                        <input matInput
                               [value]="isViewMode ? (selectedOrgUnitPath || selectedOrgUnitName || '-') : (selectedOrgUnitPath || selectedOrgUnitName)"
                               [placeholder]="isViewMode ? '' : ('employeesCatalog.orgUnitPicker.placeholder' | translate)"
                               [disabled]="!isViewMode && !canSelectOrgUnit"
                               [required]="!isViewMode"
                               readonly
                               (click)="canSelectOrgUnit && openOrgUnitPicker()">
                        @if (!isViewMode) {
                        <button mat-icon-button
                                matSuffix
                                type="button"
                                [disabled]="!canSelectOrgUnit"
                                (click)="openOrgUnitPicker()">
                          <mat-icon>{{ canSelectOrgUnit ? 'account_tree' : 'lock_outline' }}</mat-icon>
                        </button>
                        }
                        @if (!isViewMode) {
                        <mat-hint>
                          {{ canSelectOrgUnit
                          ? ('employeesCatalog.orgUnitPicker.leafOnlyHint' | translate)
                          : ('employeesCatalog.orgUnitPicker.selectCompanyFirstHint' | translate) }}
                        </mat-hint>
                        }
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="employees-detail-page__section-card employees-detail-page__section-card--identity"
                       [class.employees-detail-page__section-card--locked]="!isViewMode && !isOrganizationComplete">
                    <div class="employees-detail-page__section-header employees-detail-page__section-header--step">
                      <div class="employees-detail-page__step-heading">
                        <span class="employees-detail-page__step-number">2</span>
                        <div>
                          <span class="employees-detail-page__step-eyebrow">{{ 'employeesCatalog.general.step' | translate:{ step: 2 } }}</span>
                          <h4>{{ 'employeesCatalog.general.sections.identity' | translate }}</h4>
                          <p>{{ 'employeesCatalog.general.descriptions.identity' | translate }}</p>
                        </div>
                      </div>
                      <span class="employees-detail-page__step-status"
                            [class.employees-detail-page__step-status--complete]="isViewMode || isOrganizationComplete">
                        <mat-icon>{{ isViewMode || isOrganizationComplete ? 'lock_open' : 'lock_outline' }}</mat-icon>
                        {{ (isViewMode || isOrganizationComplete ? 'employeesCatalog.general.stepAvailable' : 'employeesCatalog.general.stepPending') | translate }}
                      </span>
                    </div>

                    @if (!isViewMode && !isOrganizationComplete) {
                    <div class="employees-detail-page__locked-state">
                      <span class="employees-detail-page__locked-state-icon">
                        <mat-icon>badge</mat-icon>
                      </span>
                      <div>
                        <strong>{{ 'employeesCatalog.general.identityLockedTitle' | translate }}</strong>
                        <p>{{ 'employeesCatalog.general.completeOrganizationFirst' | translate }}</p>
                      </div>
                    </div>
                    } @else {
                    <div class="employees-detail-page__form employees-detail-page__form--identity"
                         [attr.aria-disabled]="false">
                      @if (shouldShowEmployeeNumberField) {
                      <mat-form-field subscriptSizing="dynamic"
                                      appearance="outline"
                                      class="employees-detail-page__org-unit-field employees-detail-page__identity-field--full-row">
                        <mat-label>{{ 'employeesCatalog.fields.employeeNumber' | translate }}</mat-label>
                        <input matInput
                               data-no-spaces="true"
                               name="employeeIdentifier"
                               autocomplete="off"
                               [(ngModel)]="entityForm.employeeNumber"
                               [required]="isEmployeeNumberRequired"
                               [maxlength]="isCreateMode && employeeNumberingMode === 'manual' && employeeNumberPadLength ? employeeNumberPadLength : null"
                               (ngModelChange)="onEmployeeNumberChange($event)"
                               [readonly]="isViewMode">
                        @if (shouldShowEmployeeNumberHelp) {
                        <button mat-icon-button
                                matSuffix
                                type="button"
                                tabindex="-1"
                                [matTooltip]="employeeNumberHelpTooltip"
                                [attr.aria-label]="employeeNumberHelpTooltip">
                          <mat-icon>info</mat-icon>
                        </button>
                        }
                        @if (!isViewMode && hasInvalidEmployeeNumberLength) {
                        <mat-error>{{ 'employeesCatalog.notifications.validationEmployeeNumberLength' | translate:{ length: employeeNumberPadLength } }}</mat-error>
                        }
                      </mat-form-field>
                      }

                      <mat-form-field subscriptSizing="dynamic"
                                      appearance="outline">
                        <mat-label>{{ 'employeesCatalog.fields.lastName' | translate }}</mat-label>
                        <input matInput
                               name="employeeLastName"
                               autocomplete="family-name"
                               [(ngModel)]="entityForm.lastName"
                               [required]="!isViewMode"
                               [readonly]="isViewMode">
                      </mat-form-field>

                      <mat-form-field subscriptSizing="dynamic"
                                      appearance="outline">
                        <mat-label>{{ 'employeesCatalog.fields.secondLastName' | translate }}</mat-label>
                        <input matInput
                               name="employeeSecondLastName"
                               autocomplete="off"
                               [(ngModel)]="entityForm.secondLastName"
                               [readonly]="isViewMode">
                      </mat-form-field>

                      <mat-form-field subscriptSizing="dynamic"
                                      appearance="outline"
                                      class="employees-detail-page__identity-field--full-row">
                        <mat-label>{{ 'employeesCatalog.fields.firstName' | translate }}</mat-label>
                        <input matInput
                               name="employeeFirstName"
                               autocomplete="given-name"
                               [(ngModel)]="entityForm.firstName"
                               [required]="!isViewMode"
                               [readonly]="isViewMode">
                      </mat-form-field>

                      <p-iftalabel class="employees-detail-page__date-field employees-detail-page__date-field--full-row">
                        <p-datepicker inputId="employee-hire-date"
                                      name="employmentStartDate"
                                      [ngModel]="entityDatePickerValues.hireDate"
                                      (ngModelChange)="onEmployeeDateChange('hireDate', $event)"
                                      (onInput)="onManualEmployeeDateInput('hireDate', $event)"
                                      dateFormat="dd/mm/yy"
                                      iconDisplay="input"
                                      [showIcon]="true"
                                      [fluid]="true"
                                      panelStyleClass="app-date-picker-panel"
                                      [disabled]="isViewMode"
                                      appendTo="body">
                        </p-datepicker>
                        <label for="employee-hire-date">
                          {{ 'employeesCatalog.fields.hireDate' | translate }}
                          @if (isCreateMode) { <span aria-hidden="true">*</span> }
                        </label>
                      </p-iftalabel>

                      @if (!isCreateMode) {
                        <p-iftalabel class="employees-detail-page__date-field employees-detail-page__date-field--full-row">
                          <p-datepicker inputId="employee-termination-date"
                                        name="employmentEndDate"
                                        [ngModel]="entityDatePickerValues.terminationDate"
                                        (ngModelChange)="onEmployeeDateChange('terminationDate', $event)"
                                        (onInput)="onManualEmployeeDateInput('terminationDate', $event)"
                                        dateFormat="dd/mm/yy"
                                        iconDisplay="input"
                                        [showIcon]="true"
                                        [fluid]="true"
                                        panelStyleClass="app-date-picker-panel"
                                        [disabled]="isViewMode"
                                        appendTo="body">
                          </p-datepicker>
                          <label for="employee-termination-date">{{ 'employeesCatalog.fields.terminationDate' | translate }}</label>
                        </p-iftalabel>
                      }

                      @if (!isCreateMode) {
                      <div class="employees-detail-page__status-picker employees-detail-page__full-span">
                        <span class="employees-detail-page__status-picker-label">{{ 'employeesCatalog.fields.status' | translate }}</span>
                        <div class="employees-detail-page__status-options"
                             role="radiogroup"
                             [attr.aria-label]="'employeesCatalog.fields.status' | translate">
                          <button type="button"
                                  class="employees-detail-page__status-option"
                                  [class.employees-detail-page__status-option--active]="entityForm.status === 'active'"
                                  [disabled]="isViewMode"
                                  [attr.aria-checked]="entityForm.status === 'active'"
                                  (click)="entityForm.status = 'active'">
                            <span>{{ 'common.status.active' | translate }}</span>
                            <small>{{ 'employeesCatalog.general.statusDescriptions.active' | translate }}</small>
                          </button>
                          <button type="button"
                                  class="employees-detail-page__status-option employees-detail-page__status-option--danger"
                                  [class.employees-detail-page__status-option--active]="entityForm.status === 'inactive'"
                                  [disabled]="isViewMode"
                                  [attr.aria-checked]="entityForm.status === 'inactive'"
                                  (click)="entityForm.status = 'inactive'">
                            <span>{{ 'common.status.inactive' | translate }}</span>
                            <small>{{ 'employeesCatalog.general.statusDescriptions.inactive' | translate }}</small>
                          </button>
                        </div>
                      </div>
                      }
                    </div>
                    }
                  </div>

                  @if (shouldShowLoginSection) {
                  <div class="employees-detail-page__section-card">
                    <div class="employees-detail-page__section-header">
                      <h4>{{ 'employeesCatalog.general.sections.login' | translate }}</h4>
                      <p>{{ 'employeesCatalog.general.descriptions.login' | translate }}</p>
                    </div>

                    <div class="employees-detail-page__form">
                      <mat-form-field subscriptSizing="dynamic"
                                      appearance="outline">
                        <mat-label>{{ 'employeesCatalog.fields.email' | translate }}</mat-label>
                        <input matInput
                               type="email"
                               name="employeeEmail"
                               autocomplete="email"
                               data-preserve-case="true"
                               [(ngModel)]="entityForm.email"
                               (ngModelChange)="onEmailChange()"
                               [required]="isEmailRequired"
                               [readonly]="isViewMode"
                               [placeholder]="isEmailRequired ? ('employeesCatalog.provisioning.emailRequiredPlaceholder' | translate) : ('employeesCatalog.general.optionalPlaceholder' | translate)">
                        @if (!isViewMode && isEmailRequired && !entityForm.email.trim()) {
                        <mat-error>{{ 'employeesCatalog.notifications.validationEmailRequiredForMobile' | translate }}</mat-error>
                        }
                        @if (!isViewMode && hasInvalidEmail) {
                        <mat-error>{{ 'employeesCatalog.notifications.validationEmail' | translate }}</mat-error>
                        }
                        @if (!isViewMode && emailServerError) {
                        <mat-hint class="employees-detail-page__field-error">{{ emailServerError }}</mat-hint>
                        } @else if (isCreateMode && requiresMobileUser) {
                        <mat-hint>{{ 'employeesCatalog.provisioning.mobileUserHint' | translate }}</mat-hint>
                        } @else if (isCreateMode && isLoadingEffectiveConfig) {
                        <mat-hint>{{ 'employeesCatalog.provisioning.checkingConfig' | translate }}</mat-hint>
                        } @else if (isCreateMode && effectiveConfigError) {
                        <mat-hint class="employees-detail-page__field-warning">{{ effectiveConfigError }}</mat-hint>
                        }
                      </mat-form-field>

                    </div>
                  </div>
                  }

                </div>

              </div>
            </div>
          </mat-tab>

          <mat-tab [label]="'employeesCatalog.tabs.workAssignment' | translate">
            <div class="employees-detail-page__assignment-tab"
                 style="overflow: hidden;">
              <div class="employees-detail-page__assignment-header">
                <div>
                  <h4>{{ 'employeesCatalog.workAssignment.title' | translate }}</h4>
                  <p>{{ 'employeesCatalog.workAssignment.description' | translate }}</p>
                </div>

                @if (!isViewMode) {

                <div class="employees-detail-page__assignment-toggle">
                  <span>{{ 'employeesCatalog.workAssignment.enabled' | translate }}</span>
                  <mat-slide-toggle [(ngModel)]="workAssignmentForm.enabled"
                                    (ngModelChange)="onWorkAssignmentToggle()"></mat-slide-toggle>
                </div>
                }
              </div>

              <div class="employees-detail-page__inheritance-banner"
                   [class.employees-detail-page__inheritance-banner--own]="workAssignmentForm.enabled">
                <mat-icon>{{ workAssignmentForm.enabled ? 'tune' : 'account_tree' }}</mat-icon>
                <div>
                  <span>{{ workAssignmentForm.enabled ? ('operationalConfigInheritance.ownLabel' | translate) : ('operationalConfigInheritance.inheritedLabel' | translate) }}</span>
                  <strong>{{ workAssignmentOriginLabel }}</strong>
                  @if (!workAssignmentForm.enabled && !isViewMode) {
                  <small>{{ 'operationalConfigInheritance.enableToOverride' | translate }}</small>
                  }
                </div>
              </div>

              <div class="employees-detail-page__assignment-layout employees-detail-page__assignment-layout--full">
                <div class="employees-detail-page__assignment-main">
                  <div class="employees-detail-page__section-card employees-detail-page__full-width employees-detail-page__assignment-config-card">
                    @if (isViewMode) {
                    <div class="employees-detail-page__assignment-config-grid">
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'employeesCatalog.workAssignment.workCycleId' | translate }}</span>
                        <strong>{{ selectedWorkCycleName }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'employeesCatalog.workAssignment.restConfigurationId' | translate }}</span>
                        <strong>{{ selectedRestConfigurationName }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'employeesCatalog.workAssignment.cycleStartDate' | translate }}</span>
                        <strong>{{ displayedWorkAssignment?.cycleStartDate || '-' }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'employeesCatalog.workAssignment.effectiveFrom' | translate }}</span>
                        <strong>{{ displayedWorkAssignment?.effectiveFrom || '-' }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'employeesCatalog.workAssignment.effectiveTo' | translate }}</span>
                        <strong>{{ displayedWorkAssignment?.effectiveTo || ('employeesCatalog.workAssignment.openEnded' | translate) }}</strong>
                      </div>
                    </div>
                    } @else {
                    <div class="employees-detail-page__assignment-config-grid">
                      <mat-form-field subscriptSizing="dynamic"
                                      appearance="outline">
                        <mat-label>{{ 'employeesCatalog.workAssignment.workCycleId' | translate }}</mat-label>
                        <mat-select [(ngModel)]="workAssignmentForm.workCycleId"
                                    (ngModelChange)="onWorkCycleChange()"
                                    [required]="workAssignmentForm.enabled"
                                    [disabled]="!workAssignmentForm.enabled">
                          <mat-option value="">{{ 'common.select' | translate }}</mat-option>
                          @for (cycle of workCycles; track cycle.workCycleId) {
                          <mat-option [value]="cycle.workCycleId">{{ cycle.name }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field subscriptSizing="dynamic"
                                      appearance="outline">
                        <mat-label>{{ 'employeesCatalog.workAssignment.restConfigurationId' | translate }}</mat-label>
                        <mat-select [(ngModel)]="workAssignmentForm.restConfigurationId"
                                    [disabled]="!workAssignmentForm.enabled">
                          <mat-option value="">{{ 'common.select' | translate }}</mat-option>
                          @for (restConfiguration of restConfigurations; track restConfiguration.restConfigurationId) {
                          <mat-option [value]="restConfiguration.restConfigurationId">{{ restConfiguration.name }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>

                      <!-- Cycle offset is intentionally hidden until offset-based assignments are enabled again. -->
                      <div class="employees-detail-page__assignment-dates-row">
                        <p-iftalabel class="employees-detail-page__date-field">
                          <p-datepicker inputId="employee-cycle-start-date"
                                        name="workCycleStartDate"
                                        [ngModel]="workAssignmentDatePickerValues.cycleStartDate"
                                        (ngModelChange)="onWorkAssignmentPickerDateChange('cycleStartDate', $event)"
                                        (onInput)="onManualWorkAssignmentDateInput('cycleStartDate', $event)"
                                        dateFormat="dd/mm/yy"
                                        iconDisplay="input"
                                        [showIcon]="true"
                                        [fluid]="true"
                                        panelStyleClass="app-date-picker-panel"
                                        [disabled]="!workAssignmentForm.enabled"
                                        appendTo="body">
                          </p-datepicker>
                          <label for="employee-cycle-start-date">
                            {{ 'employeesCatalog.workAssignment.cycleStartDate' | translate }} <span aria-hidden="true">*</span>
                          </label>
                        </p-iftalabel>

                        <p-iftalabel class="employees-detail-page__date-field">
                          <p-datepicker inputId="employee-effective-from"
                                        name="workAssignmentEffectiveFrom"
                                        [ngModel]="workAssignmentDatePickerValues.effectiveFrom"
                                        (ngModelChange)="onWorkAssignmentPickerDateChange('effectiveFrom', $event)"
                                        (onInput)="onManualWorkAssignmentDateInput('effectiveFrom', $event)"
                                        dateFormat="dd/mm/yy"
                                        iconDisplay="input"
                                        [showIcon]="true"
                                        [fluid]="true"
                                        panelStyleClass="app-date-picker-panel"
                                        [disabled]="!workAssignmentForm.enabled"
                                        appendTo="body">
                          </p-datepicker>
                          <label for="employee-effective-from">{{ 'employeesCatalog.workAssignment.effectiveFrom' | translate }}</label>
                        </p-iftalabel>

                        <p-iftalabel class="employees-detail-page__date-field">
                          <p-datepicker inputId="employee-effective-to"
                                        name="workAssignmentEffectiveTo"
                                        [ngModel]="workAssignmentDatePickerValues.effectiveTo"
                                        (ngModelChange)="onWorkAssignmentPickerDateChange('effectiveTo', $event)"
                                        (onInput)="onManualWorkAssignmentDateInput('effectiveTo', $event)"
                                        dateFormat="dd/mm/yy"
                                        iconDisplay="input"
                                        [showIcon]="true"
                                        [fluid]="true"
                                        panelStyleClass="app-date-picker-panel"
                                        [disabled]="!workAssignmentForm.enabled"
                                        [placeholder]="'employeesCatalog.workAssignment.openEnded' | translate"
                                        appendTo="body">
                          </p-datepicker>
                          <label for="employee-effective-to">{{ 'employeesCatalog.workAssignment.effectiveTo' | translate }}</label>
                        </p-iftalabel>
                      </div>
                    </div>
                    }
                  </div>

                  <div class="employees-detail-page__section-card employees-detail-page__full-width employees-detail-page__rules-card">
                    <div class="employees-detail-page__section-header employees-detail-page__rules-header">
                      <span>
                        <h5>{{ 'workAssignmentRules.title' | translate }}</h5>
                        <p>{{ 'workAssignmentRules.description' | translate }}</p>
                      </span>
                    </div>

                    @if (isViewMode) {
                    <div class="employees-detail-page__assignment-grid">
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'workAssignmentRules.entryToleranceMinutes' | translate }}</span>
                        <strong>{{ displayedWorkAssignment?.toleranceRules?.entryToleranceMinutes ?? '-' }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'workAssignmentRules.earlyExitToleranceMinutes' | translate }}</span>
                        <strong>{{ displayedWorkAssignment?.toleranceRules?.earlyExitToleranceMinutes ?? '-' }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'workAssignmentRules.roundingMarginMinutes' | translate }}</span>
                        <strong>{{ displayedWorkAssignment?.toleranceRules?.roundingMarginMinutes ?? '-' }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'workAssignmentRules.ignoreOvertime' | translate }}</span>
                        <strong>{{ displayedWorkAssignment?.overtimePolicy?.ignoreOvertime ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                    </div>
                    } @else {
                    <div class="employees-detail-page__rules-grid">
                      <div class="employees-detail-page__rule-field">
                        <mat-form-field subscriptSizing="dynamic" appearance="outline">
                          <mat-label>{{ 'workAssignmentRules.entryToleranceMinutes' | translate }}</mat-label>
                          <input matInput type="number" min="0" step="1"
                                 [(ngModel)]="workAssignmentForm.toleranceRules.entryToleranceMinutes"
                                 [disabled]="!workAssignmentForm.enabled">
                        </mat-form-field>
                      </div>
                      <div class="employees-detail-page__rule-field">
                        <mat-form-field subscriptSizing="dynamic" appearance="outline">
                          <mat-label>{{ 'workAssignmentRules.earlyExitToleranceMinutes' | translate }}</mat-label>
                          <input matInput type="number" min="0" step="1"
                                 [(ngModel)]="workAssignmentForm.toleranceRules.earlyExitToleranceMinutes"
                                 [disabled]="!workAssignmentForm.enabled">
                        </mat-form-field>
                      </div>
                      <div class="employees-detail-page__rule-field">
                        <mat-form-field subscriptSizing="dynamic" appearance="outline">
                          <mat-label>{{ 'workAssignmentRules.roundingMarginMinutes' | translate }}</mat-label>
                          <input matInput type="number" min="0" step="1"
                                 [(ngModel)]="workAssignmentForm.toleranceRules.roundingMarginMinutes"
                                 [disabled]="!workAssignmentForm.enabled">
                        </mat-form-field>
                      </div>
                      <div class="employees-detail-page__rules-toggle employees-detail-page__rules-toggle--wide">
                        <mat-icon class="employees-detail-page__rules-toggle-icon">timer_off</mat-icon>
                        <mat-slide-toggle [(ngModel)]="workAssignmentForm.overtimePolicy.ignoreOvertime"
                                          [disabled]="!workAssignmentForm.enabled">
                          {{ 'workAssignmentRules.ignoreOvertime' | translate }}
                        </mat-slide-toggle>
                      </div>
                    </div>
                    }
                  </div>

                  <div class="employees-detail-page__section-card employees-detail-page__full-width employees-detail-page__cycle-card">
                    <div class="employees-detail-page__section-header">
                      <h4>{{ 'employeesCatalog.workAssignment.cyclePreview.title' | translate }}</h4>
                      <p>{{ 'employeesCatalog.workAssignment.cyclePreview.description' | translate }}</p>
                    </div>

                    @if (assignmentSelectedScheduleMonth; as scheduleMonth) {
                    <div class="employees-detail-page__cycle-calendar">
                      <div class="employees-detail-page__cycle-calendar-toolbar">
                        <button mat-icon-button
                                type="button"
                                [disabled]="!hasPreviousAssignmentScheduleMonth"
                                (click)="showPreviousAssignmentScheduleMonth()">
                          <mat-icon>chevron_left</mat-icon>
                        </button>

                        <strong class="employees-detail-page__cycle-calendar-title">{{ scheduleMonth.label }}</strong>

                        <button mat-icon-button
                                type="button"
                                [disabled]="!hasNextAssignmentScheduleMonth"
                                (click)="showNextAssignmentScheduleMonth()">
                          <mat-icon>chevron_right</mat-icon>
                        </button>
                      </div>

                      <div class="employees-detail-page__cycle-planner-head">
                        @for (weekday of assignmentWeekdayLabels; track weekday) {
                        <div class="employees-detail-page__cycle-planner-head-cell">{{ weekday }}</div>
                        }
                      </div>

                      <div class="employees-detail-page__cycle-planner-weeks">
                        @for (week of [0, 1, 2, 3, 4, 5]; track week) {
                        <div class="employees-detail-page__cycle-planner-week">
                          @for (day of scheduleMonth.days.slice(week * 7, (week + 1) * 7); track $index) {
                          <article class="employees-detail-page__cycle-planner-cell"
                                   [class.employees-detail-page__cycle-planner-cell--outside]="!day.isCurrentMonth"
                                   [class.employees-detail-page__cycle-planner-cell--rest]="day.previewDay?.isRest"
                                   [class.employees-detail-page__cycle-planner-cell--range]="day.isInRange"
                                   [class.employees-detail-page__cycle-planner-cell--start]="day.isStart"
                                   [class.employees-detail-page__cycle-planner-cell--end]="day.isEnd">
                            <div class="employees-detail-page__cycle-planner-cell-top">
                              <strong class="employees-detail-page__cycle-planner-date">{{ day.dayNumber }}</strong>
                              @if (day.previewDay) {
                              <span class="employees-detail-page__cycle-planner-order">
                                {{ 'employeesCatalog.workAssignment.cyclePreview.day' | translate:{ day: day.previewDay.dayOrder } }}
                              </span>
                              }
                            </div>

                            @if (day.previewDay) {
                            <div class="employees-detail-page__cycle-planner-body">
                              <span class="employees-detail-page__cycle-planner-weekday">{{ day.weekdayLabel }}</span>
                              <strong class="employees-detail-page__cycle-planner-range">{{ day.previewDay.scheduleRange }}</strong>
                              <span class="employees-detail-page__cycle-planner-name">{{ day.previewDay.scheduleName }}</span>
                              <small class="employees-detail-page__cycle-planner-hours">{{ day.previewDay.expectedHours }}</small>
                            </div>
                            } @else {
                            <div class="employees-detail-page__cycle-planner-body employees-detail-page__cycle-planner-body--empty">
                              <span class="employees-detail-page__cycle-planner-muted">
                                {{ 'employeesCatalog.workAssignment.cyclePreview.outsideRange' | translate }}
                              </span>
                            </div>
                            }
                          </article>
                          }
                        </div>
                        }
                      </div>
                    </div>
                    } @else {
                    <div class="employees-detail-page__cycle-preview-empty">
                      <mat-icon>event_busy</mat-icon>
                      <span>{{ 'employeesCatalog.workAssignment.cyclePreview.empty' | translate }}</span>
                    </div>
                    }
                  </div>
                </div>

              </div>
            </div>
          </mat-tab>

          @if (!isCreateMode) {
          <mat-tab [label]="'employeesCatalog.tabs.biometricData' | translate">
            <div class="employees-detail-page__biometrics-tab">
              <!-- <div class="employees-detail-page__assignment-header">
              <div>
                <h4>{{ 'employeesCatalog.biometricData.title' | translate }}</h4>
                <p>{{ 'employeesCatalog.biometricData.description' | translate }}</p>
              </div>
            </div> -->

              <div class="employees-detail-page__section-card">
                <div class="employees-detail-page__section-header">
                  <h4>{{ 'employeesCatalog.biometricData.selectionTitle' | translate }}</h4>
                  <p>{{ 'employeesCatalog.biometricData.selectionDescription' | translate }}</p>
                </div>

                <div class="employees-detail-page__assignment-grid employees-detail-page__biometrics-grid">
                  <div class="employees-detail-page__soft-card employees-detail-page__biometric-card employees-detail-page__biometric-card--mobile-face">
                    <div class="employees-detail-page__biometric-card-header">
                      <div class="employees-detail-page__biometric-icon">
                        <img src="assets/images/biometric-icons/face.svg"
                             alt="Mobile face profile"
                             class="employees-detail-page__biometric-icon-image">
                      </div>
                      <div class="employees-detail-page__biometric-heading">
                        <span>{{ 'employeesCatalog.biometricData.mobileFaceTitle' | translate }}</span>
                        <strong>
                          {{
                          (hasMobileFaceProfile
                          ? 'employeesCatalog.biometricData.mobileFaceRegistered'
                          : 'employeesCatalog.biometricData.mobileFaceNotRegistered') | translate
                          }}
                        </strong>
                      </div>
                      @if (hasMobileFaceProfile) {
                      <span class="employees-detail-page__biometric-slot employees-detail-page__biometric-slot--face">
                        {{ 'employeesCatalog.biometricData.face' | translate }}
                      </span>
                      }
                    </div>

                    <p class="employees-detail-page__biometric-description">
                      {{ 'employeesCatalog.biometricData.mobileFaceDescription' | translate }}
                    </p>

                    <div class="employees-detail-page__biometric-meta">
                      <div class="employees-detail-page__biometric-meta-item">
                        <span>{{ 'employeesCatalog.biometricData.mobileFaceSource' | translate }}</span>
                        <strong>{{ mobileFaceProfile?.capturedFrom || '-' }}</strong>
                      </div>
                      <div class="employees-detail-page__biometric-meta-item">
                        <span>{{ 'employeesCatalog.biometricData.mobileFaceSamples' | translate }}</span>
                        <strong>{{ mobileFaceProfile?.sampleCount ?? '-' }}</strong>
                      </div>
                      <div class="employees-detail-page__biometric-meta-item">
                        <span>{{ 'employeesCatalog.biometricData.mobileFaceEmbeddingSize' | translate }}</span>
                        <strong>{{ mobileFaceProfile?.embeddingSize ?? '-' }}</strong>
                      </div>
                      <div class="employees-detail-page__biometric-meta-item">
                        <span>{{ 'employeesCatalog.biometricData.mobileFaceThreshold' | translate }}</span>
                        <strong>{{ mobileFaceProfile?.threshold ?? '-' }}</strong>
                      </div>
                    </div>

                    @if (!isViewMode) {
                    <div class="employees-detail-page__biometric-actions">
                      <button mat-stroked-button
                              type="button"
                              class="btn-tone-primary"
                              [disabled]="isSavingMobileFaceProfile || isDeletingMobileFaceProfile"
                              (click)="toggleMobileFaceProfileForm()">
                        <mat-icon>{{ hasMobileFaceProfile ? 'sync' : 'add_circle' }}</mat-icon>
                        {{
                        (hasMobileFaceProfile
                        ? 'employeesCatalog.biometricData.mobileFaceReplace'
                        : 'employeesCatalog.biometricData.mobileFaceCreate') | translate
                        }}
                      </button>

                      @if (hasMobileFaceProfile) {
                      <button mat-stroked-button
                              type="button"
                              color="warn"
                              [disabled]="isDeletingMobileFaceProfile || isSavingMobileFaceProfile"
                              (click)="deleteMobileFaceProfile()">
                        <mat-icon>delete</mat-icon>
                        {{ 'employeesCatalog.biometricData.mobileFaceDelete' | translate }}
                      </button>
                      }
                    </div>
                    }

                    @if (isMobileFaceFormVisible && !isViewMode) {
                    <div class="employees-detail-page__biometric-form">
                      <mat-form-field appearance="outline"
                                      subscriptSizing="dynamic">
                        <mat-label>{{ 'employeesCatalog.biometricData.mobileFaceEmbeddingInput' | translate }}</mat-label>
                        <textarea matInput
                                  rows="5"
                                  [(ngModel)]="mobileFaceProfileForm.embeddingText"
                                  [ngModelOptions]="{ standalone: true }"
                                  [placeholder]="'employeesCatalog.biometricData.mobileFaceEmbeddingPlaceholder' | translate"></textarea>
                        <mat-hint>{{ 'employeesCatalog.biometricData.mobileFaceEmbeddingHint' | translate }}</mat-hint>
                      </mat-form-field>

                      <div class="employees-detail-page__biometric-form-grid">
                        <mat-form-field appearance="outline"
                                        subscriptSizing="dynamic">
                          <mat-label>{{ 'employeesCatalog.biometricData.mobileFaceEmbeddingSize' | translate }}</mat-label>
                          <input matInput
                                 type="number"
                                 [(ngModel)]="mobileFaceProfileForm.embeddingSize"
                                 [ngModelOptions]="{ standalone: true }">
                        </mat-form-field>

                        <mat-form-field appearance="outline"
                                        subscriptSizing="dynamic">
                          <mat-label>{{ 'employeesCatalog.biometricData.mobileFaceSamples' | translate }}</mat-label>
                          <input matInput
                                 type="number"
                                 [(ngModel)]="mobileFaceProfileForm.sampleCount"
                                 [ngModelOptions]="{ standalone: true }">
                        </mat-form-field>

                        <mat-form-field appearance="outline"
                                        subscriptSizing="dynamic">
                          <mat-label>{{ 'employeesCatalog.biometricData.mobileFaceThreshold' | translate }}</mat-label>
                          <input matInput
                                 type="number"
                                 step="0.01"
                                 [(ngModel)]="mobileFaceProfileForm.threshold"
                                 [ngModelOptions]="{ standalone: true }">
                        </mat-form-field>
                      </div>

                      <div class="employees-detail-page__biometric-actions">
                        <button mat-flat-button
                                type="button"
                                class="btn-tone-primary"
                                [disabled]="isSavingMobileFaceProfile"
                                (click)="saveMobileFaceProfile()">
                          <mat-icon>save</mat-icon>
                          {{ 'common.save' | translate }}
                        </button>
                        <button mat-stroked-button
                                type="button"
                                [disabled]="isSavingMobileFaceProfile"
                                (click)="cancelMobileFaceProfileForm()">
                          {{ 'common.cancel' | translate }}
                        </button>
                      </div>
                    </div>
                    }
                  </div>
                </div>

                @if (activeBiometricTemplates.length) {
                <div class="employees-detail-page__assignment-grid employees-detail-page__biometrics-grid">
                  @for (template of activeBiometricTemplates; track template.employeeBiometricTemplateId) {
                  <div class="employees-detail-page__soft-card employees-detail-page__biometric-card">
                    <div class="employees-detail-page__biometric-card-header">
                      <div class="employees-detail-page__biometric-icon">
                        @if (template.modality === 'face') {
                        <img src="assets/images/biometric-icons/face.svg"
                             alt="Face biometric"
                             class="employees-detail-page__biometric-icon-image">
                        } @else {
                        <mat-icon>{{ getBiometricTemplateIcon(template) }}</mat-icon>
                        }
                      </div>
                      <div class="employees-detail-page__biometric-heading">
                        <span>{{ getBiometricTemplateTypeLabel(template) }}</span>
                        <strong>{{ getBiometricTemplateLabel(template) }}</strong>
                      </div>
                      @if (template.modality === 'fingerprint') {
                      <span class="employees-detail-page__biometric-slot">
                        {{ 'employeesCatalog.biometricData.templateSlot' | translate }} {{ template.templateSlot ?? '-' }}
                      </span>
                      }
                    </div>

                    <div class="employees-detail-page__biometric-meta">
                      <div class="employees-detail-page__biometric-meta-item">
                        <span>{{ 'employeesCatalog.biometricData.deviceSerial' | translate }}</span>
                        <strong>{{ template.sourceDeviceSerial || '-' }}</strong>
                      </div>
                      <div class="employees-detail-page__biometric-meta-item">
                        <span>{{ 'employeesCatalog.biometricData.capturedAt' | translate }}</span>
                        <strong>{{ formatDateTime(template.capturedAt) }}</strong>
                      </div>
                    </div>
                  </div>
                  }
                </div>
                } @else if (!hasMobileFaceProfile) {
                <div class="employees-detail-page__soft-card employees-detail-page__biometric-empty">
                  <mat-icon>fingerprint</mat-icon>
                  <span>{{ 'employeesCatalog.biometricData.emptyTitle' | translate }}</span>
                  <strong>{{ 'employeesCatalog.biometricData.emptyDescription' | translate }}</strong>
                </div>
                }
              </div>
            </div>
          </mat-tab>
          <mat-tab [label]="'employeesCatalog.tabs.devices' | translate">
            <div class="employees-detail-page__devices-tab">
              <div class="employees-detail-page__assignment-header">
                <div>
                  <h4>{{ 'devicesCatalog.breadcrumb' | translate }}</h4>
                  <p>{{ 'employeesCatalog.devices.description' | translate }}</p>
                </div>

                @if (canEnrollFingerprint) {
                <div class="employees-detail-page__assignment-toggle">
                  <button mat-stroked-button
                          class="btn-tone-primary"
                          type="button"
                          (click)="openFingerprintEnrollmentDialog()">
                    <mat-icon>fingerprint</mat-icon>
                    {{ 'employeesCatalog.devices.enrollFingerprint' | translate }}
                  </button>
                </div>
                }
              </div>

              <div class="employees-detail-page__devices-summary">
                <div class="employees-detail-page__general-chip">
                  <span>{{ 'employeesCatalog.devices.assignedCount' | translate }}</span>
                  <strong>{{ assignedDeviceCount }}</strong>
                </div>
                <div class="employees-detail-page__general-chip">
                  <span>{{ 'employeesCatalog.devices.companyScopedCount' | translate }}</span>
                  <strong>{{ availableDeviceCount }}</strong>
                </div>
                <div class="employees-detail-page__general-chip">
                  <span>{{ 'employeesCatalog.biometricData.fingerprint' | translate }}</span>
                  <strong>{{ fingerprintTemplates.length }}</strong>
                </div>
              </div>

              <div class="employees-detail-page__devices-layout">
                <div class="employees-detail-page__devices-main">
                  <div class="employees-detail-page__section-card">
                    <div class="employees-detail-page__section-header">
                      <h4>{{ 'employeesCatalog.devices.selectionTitle' | translate }}</h4>
                      <p>{{ 'employeesCatalog.devices.selectionDescription' | translate }}</p>
                    </div>

                    @if (isViewMode) {
                    @if (assignedDevices.length) {
                    <div class="employees-detail-page__assignment-grid employees-detail-page__devices-grid">
                      @for (device of assignedDevices; track device.deviceId) {
                      <div class="employees-detail-page__soft-card employees-detail-page__device-card">
                        <div class="employees-detail-page__device-card-header">
                          <div class="employees-detail-page__device-icon">
                            <mat-icon>devices</mat-icon>
                          </div>
                          <div>
                            <span>{{ 'devicesCatalog.fields.serial' | translate }}</span>
                            <strong>{{ device.name || device.serial || '-' }}</strong>
                          </div>
                        </div>

                        <div class="employees-detail-page__device-meta">
                          <div class="employees-detail-page__device-meta-item">
                            <span>{{ 'devicesCatalog.fields.serial' | translate }}</span>
                            <strong>{{ device.serial || '-' }}</strong>
                          </div>
                          <div class="employees-detail-page__device-meta-item">
                            <span>{{ 'employeesCatalog.fields.status' | translate }}</span>
                            <strong>{{ device.isActive === false ? ('common.status.inactive' | translate) : ('common.status.active' | translate) }}</strong>
                          </div>
                        </div>
                      </div>
                      }
                    </div>
                    } @else {
                    <div class="employees-detail-page__soft-card employees-detail-page__devices-empty">
                      <mat-icon>devices_other</mat-icon>
                      <span>{{ 'devicesCatalog.breadcrumb' | translate }}</span>
                      <strong>{{ 'employeesCatalog.devices.empty' | translate }}</strong>
                    </div>
                    }
                    } @else {
                    <div class="employees-detail-page__form">
                      <mat-form-field subscriptSizing="dynamic"
                                      appearance="outline"
                                      class="employees-detail-page__full-span employees-detail-page__full-width">
                        <mat-label>{{ 'devicesCatalog.breadcrumb' | translate }}</mat-label>
                        <mat-select [(ngModel)]="selectedDeviceIds"
                                    multiple>
                          @for (device of devices; track device.deviceId) {
                          <mat-option [value]="device.deviceId">
                            {{ device.name || device.serial }} @if (device.serial) {<span>({{ device.serial }})</span>}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    }
                  </div>
                </div>

                <aside class="employees-detail-page__devices-aside">
                  <div class="employees-detail-page__aside-card employees-detail-page__devices-aside-card">
                    <span>{{ 'employeesCatalog.devices.summaryTitle' | translate }}</span>
                    <strong>{{ 'employeesCatalog.devices.summaryDescription' | translate:{ count: assignedDeviceCount } }}</strong>
                  </div>

                  @if (assignedDevices.length) {
                  <div class="employees-detail-page__section-card employees-detail-page__devices-selection-card">
                    <div class="employees-detail-page__section-header">
                      <h4>{{ 'employeesCatalog.devices.selectedDevicesTitle' | translate }}</h4>
                      <p>{{ 'employeesCatalog.devices.selectedDevicesDescription' | translate }}</p>
                    </div>

                    <div class="employees-detail-page__devices-list">
                      @for (device of assignedDevices; track device.deviceId) {
                      <div class="employees-detail-page__devices-list-item">
                        <div class="employees-detail-page__devices-list-copy">
                          <strong>{{ device.name || device.serial || '-' }}</strong>
                          <span>{{ device.serial || '-' }}</span>
                        </div>
                        <mat-icon>check_circle</mat-icon>
                      </div>
                      }
                    </div>
                  </div>
                  } @else {
                  <div class="employees-detail-page__aside-card">
                    <span>{{ 'employeesCatalog.devices.selectedDevicesTitle' | translate }}</span>
                    <strong>{{ 'employeesCatalog.devices.empty' | translate }}</strong>
                  </div>
                  }
                </aside>
              </div>
            </div>
          </mat-tab>
          }

          @if (!isCreateMode && canReadAttendanceConfig) {
          <mat-tab [label]="'attendanceConfigsCatalog.tabLabel' | translate">
            <div class="employees-detail-page__attendance-tab">
              <div class="employees-detail-page__assignment-header">
                <div>
                  <!-- <h4>{{ 'attendanceConfigsCatalog.title' | translate }}</h4> -->
                  <p>{{ 'attendanceConfigsCatalog.description' | translate }}</p>
                </div>

                @if (!isViewMode && canManageAttendanceConfig) {
                <div class="employees-detail-page__assignment-toggle">
                  <span>{{ 'attendanceConfigsCatalog.enabled' | translate }}</span>
                  <mat-slide-toggle [(ngModel)]="attendanceConfigForm.enabled"
                                    (ngModelChange)="onAttendanceConfigToggle()"></mat-slide-toggle>
                </div>
                }
              </div>

              <div class="employees-detail-page__inheritance-banner"
                   [class.employees-detail-page__inheritance-banner--own]="attendanceConfigForm.enabled">
                <mat-icon>{{ attendanceConfigForm.enabled ? 'tune' : 'account_tree' }}</mat-icon>
                <div>
                  <span>{{ attendanceConfigForm.enabled ? ('operationalConfigInheritance.ownLabel' | translate) : ('operationalConfigInheritance.inheritedLabel' | translate) }}</span>
                  <strong>{{ attendanceConfigOriginLabel }}</strong>
                  @if (!attendanceConfigForm.enabled && !isViewMode) {
                  <small>{{ 'operationalConfigInheritance.enableToOverride' | translate }}</small>
                  }
                </div>
              </div>

              <!-- <div class="attendance-config-workspace__summary">
                <div class="employees-detail-page__general-chip">
                  <span>{{ 'attendanceConfigsCatalog.enabled' | translate }}</span>
                  <strong>{{ ((isViewMode ? !!attendanceConfig : attendanceConfigForm.enabled) ? ('common.status.active' | translate) : ('common.status.inactive' | translate)) }}</strong>
                </div>
                <div class="employees-detail-page__general-chip">
                  <span>{{ 'attendanceConfigsCatalog.fields.allowedSources' | translate }}</span>
                  <strong>{{ isViewMode ? attendanceConfigSourcesLabel : attendanceConfigFormSourcesLabel }}</strong>
                </div>
                <div class="employees-detail-page__general-chip">
                  <span>{{ 'attendanceConfigsCatalog.fields.allowedZones' | translate }}</span>
                  <strong>{{ isViewMode ? attendanceConfigZonesLabel : attendanceConfigFormZonesLabel }}</strong>
                </div>
              </div> -->

              <div class="attendance-config-workspace__layout attendance-config-workspace__layout--full">
                <div class="attendance-config-workspace__main">

                  @if (isViewMode) {
                  @if (displayedAttendanceConfig; as attendanceConfig) {
                  <div class="employees-detail-page__section-card">
                    <div class="employees-detail-page__section-header">
                      <h4>{{ 'attendanceConfigsCatalog.sections.captureDefault' | translate }}</h4>
                      <p>{{ 'attendanceConfigsCatalog.sections.captureDefaultDescription' | translate }}</p>
                    </div>

                    <div class="employees-detail-page__assignment-grid">
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.timezone' | translate }}</span>
                        <strong>{{ attendanceConfig.attendanceCapture.timezone }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.duplicateWindowSeconds' | translate }}</span>
                        <strong>{{ attendanceConfig.attendanceCapture.duplicateWindowSeconds }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.requireGeo' | translate }}</span>
                        <strong>{{ attendanceConfig.attendanceCapture.requireGeo ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.requireFaceEvidence' | translate }}</span>
                        <strong>{{ attendanceConfig.attendanceCapture.requireFaceEvidence ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.isActive' | translate }}</span>
                        <strong>{{ attendanceConfig.isActive !== false ? ('common.status.active' | translate) : ('common.status.inactive' | translate) }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'workAssignmentRules.enableAutoClose' | translate }}</span>
                        <strong>{{ attendanceConfig.turnPolicy?.enableAutoClose ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      @if (attendanceConfig.turnPolicy?.enableAutoClose) {
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'workAssignmentRules.autoCloseGraceMinutes' | translate }}</span>
                        <strong>{{ attendanceConfig.turnPolicy?.autoCloseGraceMinutes ?? '-' }}</strong>
                      </div>
                      }
                    </div>
                  </div>

                  @if (hasAttendanceConfigSourceOverrides) {
                  <div class="employees-detail-page__section-card">
                    <div class="employees-detail-page__section-header">
                      <h4>{{ 'attendanceConfigsCatalog.sections.sourceOverrides' | translate }}</h4>
                      <p>{{ 'attendanceConfigsCatalog.fields.customizeSource' | translate }}</p>
                    </div>

                    <div class="row g-3">
                      @for (source of attendanceSourceRuleOptions; track source) {
                      @if (getAttendanceConfigSourceRule(source); as sourceRule) {
                      <div class="col-12 col-md-6 col-xl-4">
                        <div class="employees-detail-page__soft-card h-100">
                          <span>{{ 'attendanceConfigsCatalog.sections.captureForSource' | translate:{ source: (getAttendanceSourceLabelKey(source) | translate) } }}</span>
                          <div class="row g-2 mt-1">
                            @if (sourceRule.timezone) {
                            <div class="col-12">
                              <span>{{ 'attendanceConfigsCatalog.fields.timezone' | translate }}</span>
                              <strong>{{ sourceRule.timezone }}</strong>
                            </div>
                            }
                            @if (sourceRule.duplicateWindowSeconds) {
                            <div class="col-12">
                              <span>{{ 'attendanceConfigsCatalog.fields.duplicateWindowSeconds' | translate }}</span>
                              <strong>{{ sourceRule.duplicateWindowSeconds }}</strong>
                            </div>
                            }
                            @if (source !== 'device' && attendanceSourceUsesGeo(source)) {
                            <div class="col-12">
                              <span>{{ 'attendanceConfigsCatalog.fields.requireGeo' | translate }}</span>
                              <strong>{{ sourceRule.requireGeo ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                            </div>
                            }
                            @if (source !== 'device') {
                            <div class="col-12">
                              <span>{{ 'attendanceConfigsCatalog.fields.requireFaceEvidence' | translate }}</span>
                              <strong>{{ sourceRule.requireFaceEvidence ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                            </div>
                            }
                            @if (source !== 'device' && attendanceSourceUsesDeviceRules(source)) {
                            <div class="col-12">
                              <span>{{ 'attendanceConfigsCatalog.fields.requireRegisteredDevice' | translate }}</span>
                              <strong>{{ sourceRule.requireRegisteredDevice ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                            </div>
                            <div class="col-12">
                              <span>{{ 'attendanceConfigsCatalog.fields.requireDeviceBinding' | translate }}</span>
                              <strong>{{ sourceRule.requireDeviceBinding ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                            </div>
                            }
                          </div>
                        </div>
                      </div>
                      }
                      }
                    </div>
                  </div>
                  }

                  <div class="employees-detail-page__section-card">
                    <div class="employees-detail-page__section-header">
                      <h4>{{ 'attendanceConfigsCatalog.sections.tracking' | translate }}</h4>
                      <p>{{ 'attendanceConfigsCatalog.fields.trackingIntervalSeconds' | translate }}</p>
                    </div>

                    <div class="employees-detail-page__assignment-grid">
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.allowedZones' | translate }}</span>
                        <strong>{{ attendanceConfigZonesLabel }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.trackable' | translate }}</span>
                        <strong>{{ attendanceConfig.tracking.trackable ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.trackingIntervalSeconds' | translate }}</span>
                        <strong>{{ attendanceTrackingIntervalLabel }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.requireOnlineConnection' | translate }}</span>
                        <strong>{{ attendanceConfig.tracking.requireOnlineConnection ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      <div class="employees-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.allowOutOfZonePunch' | translate }}</span>
                        <strong>{{ attendanceConfig.zones.allowOutOfZonePunch ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                    </div>
                  </div>
                  } @else {
                  <div class="employees-detail-page__section-card">
                    <div class="employees-detail-page__soft-card">
                      <span>{{ 'attendanceConfigsCatalog.emptyTitle' | translate }}</span>
                      <strong>{{ 'attendanceConfigsCatalog.emptyDescription' | translate }}</strong>
                    </div>
                  </div>
                  }
                  } @else {
                  <div class="employees-detail-page__section-card">
                    <div class="row g-3 attendance-config-layout">
                      <div class="col-12">
                        <mat-form-field subscriptSizing="dynamic"
                                        appearance="outline"
                                        style="width: 100%;">
                          <mat-label>{{ 'attendanceConfigsCatalog.fields.allowedSources' | translate }}</mat-label>
                          <mat-select [(ngModel)]="attendanceConfigForm.allowedSources"
                                      [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig"
                                      (ngModelChange)="onAttendanceAllowedSourcesChange()"
                                      multiple>
                            @for (source of attendanceSourceOptions; track source) {
                            <mat-option [value]="source">{{ ('attendanceConfigsCatalog.sources.' + source) | translate }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <div class="employees-detail-page__soft-card h-100">
                          <span>{{ 'workAssignmentRules.enableAutoClose' | translate }}</span>
                          <div class="row g-3 mt-1 align-items-center">
                            <div class="col-12 col-lg-auto">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.turnPolicy.enableAutoClose"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'workAssignmentRules.enableAutoClose' | translate }}
                              </mat-slide-toggle>
                            </div>
                            @if (attendanceConfigForm.turnPolicy.enableAutoClose) {
                            <div class="col-12 col-lg">
                              <mat-form-field subscriptSizing="dynamic"
                                              appearance="outline"
                                              style="width: 100%;">
                                <mat-label>{{ 'workAssignmentRules.autoCloseGraceMinutes' | translate }}</mat-label>
                                <input matInput
                                       type="number"
                                       min="0"
                                       step="1"
                                       [(ngModel)]="attendanceConfigForm.turnPolicy.autoCloseGraceMinutes"
                                       [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                              </mat-form-field>
                            </div>
                            }
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="employees-detail-page__soft-card h-100">
                          <span>{{ 'attendanceConfigsCatalog.sections.captureDefault' | translate }}</span>
                          <div class="row g-3 mt-1">
                            <div class="col-12 col-lg-6">
                              <mat-form-field subscriptSizing="dynamic"
                                              appearance="outline"
                                              style="width: 100%;">
                                <mat-label>{{ 'attendanceConfigsCatalog.fields.timezone' | translate }}</mat-label>
                                <mat-select [(ngModel)]="attendanceConfigForm.timezone"
                                            [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                  @for (timezone of attendanceTimezoneOptions; track timezone) {
                                  <mat-option [value]="timezone">{{ timezone }}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>

                            <div class="col-12 col-lg-6">
                              <mat-form-field subscriptSizing="dynamic"
                                              appearance="outline"
                                              style="width: 100%;">
                                <mat-label>{{ 'attendanceConfigsCatalog.fields.duplicateWindowSeconds' | translate }}</mat-label>
                                <input matInput
                                       type="number"
                                       min="1"
                                       step="1"
                                       [(ngModel)]="attendanceConfigForm.duplicateWindowSeconds"
                                       [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="row g-2 mt-2 row-cols-1 row-cols-md-2 row-cols-xl-5">
                            <div class="col">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.requireGeo"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'attendanceConfigsCatalog.fields.requireGeo' | translate }}
                              </mat-slide-toggle>
                            </div>
                            <div class="col">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.requireFaceEvidence"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'attendanceConfigsCatalog.fields.requireFaceEvidence' | translate }}
                              </mat-slide-toggle>
                            </div>
                          </div>
                        </div>
                      </div>

                      @if (attendanceConfigForm.allowedSources.length > 0) {
                      <div class="col-12">
                        <div class="employees-detail-page__soft-card h-100">
                          <span>{{ 'attendanceConfigsCatalog.sections.sourceOverrides' | translate }}</span>
                          <div class="row g-3 mt-1">
                            @for (source of attendanceSourceRuleOptions; track source) {
                            @if (isAttendanceSourceEnabled(source)) {
                            <div class="col-12 col-md-6 col-xl-4">
                              <div class="employees-detail-page__soft-card h-100">
                                <span>{{ 'attendanceConfigsCatalog.sections.captureForSource' | translate:{ source: (getAttendanceSourceLabelKey(source) | translate) } }}</span>
                                <div class="d-flex align-items-center gap-2 mt-2">
                                  <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].enabled"
                                                    [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig"
                                                    (ngModelChange)="onAttendanceSourceRuleToggle(source)">
                                    {{ 'attendanceConfigsCatalog.fields.customizeSource' | translate }}
                                  </mat-slide-toggle>
                                </div>

                                @if (attendanceConfigForm.sourceRules[source].enabled) {
                                <div class="row g-3 mt-1">
                                  @if (attendanceSourceUsesTimezone(source)) {
                                  <div class="col-12">
                                    <mat-form-field subscriptSizing="dynamic"
                                                    appearance="outline">
                                      <mat-label>{{ 'attendanceConfigsCatalog.fields.timezone' | translate }}</mat-label>
                                      <mat-select [(ngModel)]="attendanceConfigForm.sourceRules[source].timezone"
                                                  [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                        @for (timezone of attendanceTimezoneOptions; track timezone) {
                                        <mat-option [value]="timezone">{{ timezone }}</mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                  }

                                  @if (attendanceSourceUsesDuplicateWindow(source)) {
                                  <div class="col-12">
                                    <mat-form-field subscriptSizing="dynamic"
                                                    appearance="outline">
                                      <mat-label>{{ 'attendanceConfigsCatalog.fields.duplicateWindowSeconds' | translate }}</mat-label>
                                      <input matInput
                                             type="number"
                                             inputmode="numeric"
                                             [(ngModel)]="attendanceConfigForm.sourceRules[source].duplicateWindowSeconds"
                                             [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                    </mat-form-field>
                                  </div>
                                  }
                                </div>

                                @if (source !== 'device') {
                                <div class="row g-2 mt-2 row-cols-1 row-cols-md-2">
                                  @if (attendanceSourceUsesGeo(source)) {
                                  <div class="col">
                                    <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].requireGeo"
                                                      [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                      {{ 'attendanceConfigsCatalog.fields.requireGeo' | translate }}
                                    </mat-slide-toggle>
                                  </div>
                                  }
                                  <div class="col">
                                    <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].requireFaceEvidence"
                                                      [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                      {{ 'attendanceConfigsCatalog.fields.requireFaceEvidence' | translate }}
                                    </mat-slide-toggle>
                                  </div>
                                  @if (attendanceSourceUsesDeviceRules(source)) {
                                  <div class="col">
                                    <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].requireRegisteredDevice"
                                                      [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                      {{ 'attendanceConfigsCatalog.fields.requireRegisteredDevice' | translate }}
                                    </mat-slide-toggle>
                                  </div>
                                  <div class="col">
                                    <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].requireDeviceBinding"
                                                      [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                      {{ 'attendanceConfigsCatalog.fields.requireDeviceBinding' | translate }}
                                    </mat-slide-toggle>
                                  </div>
                                  }
                                </div>
                                }
                                } @else {
                                <strong class="mt-2 d-block">{{ 'attendanceConfigsCatalog.fields.inheritGeneralConfig' | translate }}</strong>
                                }
                              </div>
                            </div>
                            }
                            }
                          </div>
                        </div>
                      </div>
                      }

                      <div class="col-12">
                        <div class="employees-detail-page__soft-card h-100">
                          <span>{{ 'attendanceConfigsCatalog.sections.tracking' | translate }}</span>
                          <div class="row g-3 mt-1">
                            <div class="col-12 col-lg-6">
                              <mat-form-field subscriptSizing="dynamic"
                                              appearance="outline"
                                              style="width: 100%;">
                                <mat-label>{{ 'attendanceConfigsCatalog.fields.trackingIntervalSeconds' | translate }}</mat-label>
                                <mat-select [(ngModel)]="attendanceConfigForm.trackingIntervalSeconds"
                                            [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                  @for (interval of attendanceTrackingIntervalOptions; track interval) {
                                  <mat-option [value]="interval">{{ interval < 60 ? interval + ' s' : (interval / 60) + ' min' }}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-lg-6">
                              <mat-form-field subscriptSizing="dynamic"
                                              appearance="outline"
                                              style="width: 100%;">
                                <mat-label>{{ 'attendanceConfigsCatalog.fields.allowedZones' | translate }}</mat-label>
                                <mat-select [(ngModel)]="attendanceConfigForm.allowedZoneIds"
                                            [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig"
                                            multiple>
                                  @for (zone of zoneOptions; track zone.zoneId) {
                                  <mat-option [value]="zone.zoneId">{{ zone.name }}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="row g-2 mt-2 row-cols-1 row-cols-md-2 row-cols-xl-3">
                            <div class="col">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.trackable"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'attendanceConfigsCatalog.fields.trackable' | translate }}
                              </mat-slide-toggle>
                            </div>
                            <div class="col">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.requireOnlineConnection"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'attendanceConfigsCatalog.fields.requireOnlineConnection' | translate }}
                              </mat-slide-toggle>
                            </div>
                            <div class="col">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.allowOutOfZonePunch"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'attendanceConfigsCatalog.fields.allowOutOfZonePunch' | translate }}
                              </mat-slide-toggle>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                </div>

              </div>
            </div>
          </mat-tab>
          }
        </mat-tab-group>
      </div>
      }
    </mat-card>
  </div>
</section>
